import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Link, matchPath} from 'react-router-dom'
import {getLocation} from 'react-router-redux'
import cn from 'classnames'
import { ListItem } from 'material-ui/List';
import { withStyles } from 'material-ui/styles';
import flow from 'lodash/flow'
import Icon from 'material-ui/Icon'

class MenuListItem extends Component {

    state = {
        open: false
    }

    onClick = (event) => {
        const { children } = this.props;
        if(children)
            this.setState({open: !this.state.open});
        event.stopPropagation();
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.location !== nextProps.location ) {
            if(nextProps.children && nextProps.location.pathname.indexOf(nextProps.link) === 0) {
                this.setState({open: true});
            }
        }
    }

    componentDidMount() {
        if(this.props.children && this.props.location.pathname.indexOf(this.props.link) === 0) {
            this.setState({open: true});
        }
    }

    render() {
        const { first, children, link, classes, className, title, subtitle, icon } = this.props;
        const matched = matchPath(link, {
            path: this.props.location.pathname,
            exact: true,
        });

        const open = this.state.open;

        return <ListItem button={!children} classes={{root: cn(classes.menuRoot,
                {[classes.menuItemSelected]: !children && open},
                {open, first},
                className)}} onClick={this.onClick} >
            {!children &&
            <Link to={link} className={cn({active: matched})} >
                <h3 className={classes.menuItem}>{icon && <Icon className={classes.icon}>{icon}</Icon>}{title}</h3>
                {subtitle && <span>{subtitle}</span>}
            </Link>}
            {children &&
            <a className={cn(classes.withSubmenu, {open}) }>
                <h3 className={classes.menuItem}>{title}</h3>
                {subtitle && <span className={cn({open})}>{subtitle}</span>}
            </a>
            }
            {open && children}
        </ListItem>
    }
}

const mapStateToProps = (state) => ({
    location: getLocation(state),
})


const styles = theme => ({
    menuRoot: {
        lineHeight: 1.2,
        borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
        color: 'white',
        transition: 'all 0.2s ease',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'stretch',
        padding: 0,
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
        },
        '&.open:hover': {
            backgroundColor: 'transparent',
        },
        '& h3': {
            margin: 0
        },
        '& span': {
            color: 'rgba(255, 255, 255, 0.65)',
            fontSize: '0.75rem',
            fontWeight: 400,
            lineHeight: '1.375em',
            opacity: 1
        },
        '& span.open': {
        },
        '& a': {
            userSelect: 'none',
            padding: [18, 20],
            color: theme.palette.common.white,
            '&:hover': {
                color: theme.palette.common.white,
                textDecoration: 'none'
            },
            '&.active': {
                backgroundColor: 'rgba(255,255,255,0.1)'
            }
        },
        '&.small h3': {
            fontSize: 12,
            opacity: 0.85,
        },
        '& a.active h3': {
            opacity: 1,
        },
        '&.small span': {
            color: 'rgba(255, 255, 255, 0.65)',
            fontSize: '0.6rem',
            fontWeight: 400,
            lineHeight: '1.375em'
        },
        '&.small a': {
            padding: [12, 20, 12, 40],
        },
        '&.first': {
            borderTop: '1px solid rgba(255, 255, 255, 0.3)',
        }
    },
    menuItem: {
        fontSize: 14,
        fontWeight: 500,
        textTransform: 'uppercase',
        display: 'flex',
        alignItems: 'center',
    },
    withSubmenu: {
        position: 'relative',
        '&:after': {
            content: '""',
            width: 0,
            height: 0,
            position: 'absolute',
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '6px solid transparent',
            borderBottom: '6px solid white',
            top: '50%',
            right: theme.spacing.normal,
            transform: 'translate(-50%, -50%) rotate(90deg)',
            transition: 'transform 0.15s ease-in-out',
        },
        '&.open:after': {
            transform: 'translate(-50%, -50%) rotate(180deg)'
        }
    },
    icon: {
        marginRight: theme.spacing.xsmall,
    },
    menuItemSelected: {
        backgroundColor: 'rgba(255, 255, 255, 0.12)',
    },
})


export default flow([
    connect(mapStateToProps, null),
    withStyles(styles)
])(MenuListItem)


// WEBPACK FOOTER //
// ./src/components/Menu/MenuListItem.js